import { render, staticRenderFns } from "./WhatWeDo.vue?vue&type=template&id=6d8b88fc&scoped=true&"
import script from "./WhatWeDo.vue?vue&type=script&lang=js&"
export * from "./WhatWeDo.vue?vue&type=script&lang=js&"
import style0 from "./WhatWeDo.vue?vue&type=style&index=0&id=6d8b88fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8b88fc",
  null
  
)

export default component.exports